import config from 'js/app/config';
import path from 'js/lib/path';

export const AUTH_PROVIDER_LOCAL_STORAGE_KEY = 'authProvider';
export const AUTH_PROVIDER_MIN_LEN = 1;
export const AUTH_PROVIDER_MAX_LEN = 200;

// Cloudfront domain can be found at https://console.aws.amazon.com/cloudfront/home and searching for "coursera_assets"
export const REBRAND_LOGO_SRC = 'https://d2j5ihb19pt1hq.cloudfront.net/front-page-rebrand/header/rebrand-logo.svg';

export const COURSERA_LOGO_IMG_SRC = path.join(config.url.assets, 'bundles/page/assets/white-logo-on-blue-bg.png');
export const COURSERA_REBRAND_LOGO_IMG_SRC = path.join(
  config.url.assets,
  'bundles/page/assets/coursera-rebrand-logo.png'
);

export const US_BCORP_LOGO_SRC = path.join(config.url.assets, 'images/icons/2018-B-Corp-Logo-Black-S.png');
export const FRENCH_CANADIAN_BCORP_LOGO_SRC = path.join(
  config.url.assets,
  'images/icons/2018-Canada-B-Corp-Logo-S.png'
);

export const NUMBER_OF_PRODUCTS_NO_PLUS_SIGN = '10,000';
export const NUMBER_OF_PRODUCTS = `${NUMBER_OF_PRODUCTS_NO_PLUS_SIGN}+`;

/**
 * List of definitions for deep-linkable pages.
 * ORDER MATTERS! If there are multiple pattern matches, the first definition
 *   will take effect.
 *
 * @type {Array} List of {
 *   page: <String> human-readable, unique identifier for the page
 *   pattern: <RegExp> window pathname that the definition applies to
 *   webToMobilePathTranslator: <Function> that changes the window pathname
 *     to mobile deep-link target pathname.
 * }
 */
export const DEEP_LINKABLE_PAGES = [
  {
    page: 'browse-subdomain',
    pattern: /\/browse\/(.+)\/(.+)/,
    webToMobilePathTranslator: (path: $TSFixMe) => path,
  },
  {
    page: 'browse-domain',
    pattern: /\/browse\/([a-z]+)(.+)/,
    webToMobilePathTranslator: (path: $TSFixMe) => path,
  },
  {
    page: 'browse-root',
    pattern: /\/browse/,
    webToMobilePathTranslator: (path: $TSFixMe) => path.split('/').slice(0, 2).join('/'), // watch out for trailing '/'
  },
  {
    page: 'sdp',
    pattern: /\/specializations\/([a-z]+)(.+)/,
    webToMobilePathTranslator: (path: $TSFixMe) => path,
  },
  {
    page: 'ondemand-cdp-resource',
    pattern: /\/learn\/(.+)\/(supplement|exam|quiz|lecture)\/(.+)\/(.+)/,
    webToMobilePathTranslator: (path: $TSFixMe) => path.split('/').slice(0, 5).join('/'),
  },
  {
    page: 'ondemand-cdp-home-welcome',
    pattern: /\/learn\/(.+)\/home\/welcome/,
    webToMobilePathTranslator: (path: $TSFixMe) => path.split('/').slice(0, 5).join('/'),
  },
  {
    page: 'ondemand-cdp',
    pattern: /\/learn\/([^\/]+)/,
    webToMobilePathTranslator: (path: $TSFixMe) => path,
  },
];
